import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {globalStore} from "@/store/globalStore";
import {AxiosResponse} from "axios";
import {DateTime} from 'luxon';
import {reporteStore} from "@/store/reporteStore";

export class ReporteService{
    private static instance: ReporteService;

    baseURL= `${process.env.VUE_APP_URL}`;

    public static getInstance(){
        return this.instance || (this.instance = new this());
    }

    reporteStore = reporteStore();
    globalStore = globalStore();



    makePagination(page: any) {
        this.reporteStore.pagination.per_page = page.per_page;
        this.reporteStore.pagination.current_page = page.current_page;
        this.reporteStore.pagination.last_page = page.last_page;
    }

    public async getCuentaContable() {
        await http.get("getCuentaContable").subscribe({
            next: (response:AxiosResponse) => {
                this.reporteStore.cuentaContable = response.data;
            },
        })
    }

    public async ingresoCuentaContable(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.reporteStore.loading = true;
            http.get("resumenIngresosCuentaContable", {params: data}).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        this.reporteStore.resumenIngresosCuentaContable = response.data.ingresos
                        this.reporteStore.subtotales = response.data.subtotales
                        this.reporteStore.loading = false;
                    }
                },
                error: (error) => {
                    this.reporteStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async cantidadesCalculadas(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.reporteStore.loading = true;
            http.get("cantidadesCalculadas", {params: data}).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        this.reporteStore.cantidadesCalculadas = response.data.cantidadesCalculadas
                        this.reporteStore.subtotales = response.data.subtotales
                        this.reporteStore.loading = false;
                    }
                },
                error: (error) => {
                    this.reporteStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async imprimir(id:string, fechaInicial:string, fechaFinal:string) {
        await http.get(`imprimirResumenCuentaContable/${id}`).subscribe({
            next: (response:AxiosResponse) => {
                if (response.data.success === false){
                    Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                }else {
                    window.open(
                        `${this.baseURL}imprimirResumenCuentaContable/${id}`, "_blank");
                }
            },
        })
    }
}